import { render, staticRenderFns } from "./ProjectionSelect.vue?vue&type=template&id=6a05f81d"
import script from "./ProjectionSelect.vue?vue&type=script&lang=js"
export * from "./ProjectionSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports